import SEO from "../../components/SEO";
import { Link } from "react-router-dom";

export default function PrivacyPolicyPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "プライバシーポリシー - dot Blue",
    "description": "dot Blue株式会社のプライバシーポリシーです。",
    "url": `${siteUrl}/privacy-policy`,
    "publisher": {
      "@type": "Organization",
      "name": "dot Blue",
      "url": siteUrl
    }
  };

  return (
    <>
      <SEO
        title="プライバシーポリシー - dot Blue"
        description="dot Blue株式会社のプライバシーポリシーです。個人情報の取り扱いについて説明しています。"
        keywords="プライバシーポリシー, 個人情報保護, dot Blue"
        ogImage={`${siteUrl}/og-image-privacy.jpg`}
        schema={webPageSchema}
      />

      <div className="min-h-screen bg-white">
        {/* Header */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
          <div className="max-w-7xl mx-auto px-6 py-4">
            <div className="flex items-center justify-between">
              <Link to="/" className="flex items-center gap-3">
                <span className="text-xl font-bold text-gray-900">dot Blue</span>
              </Link>
              <Link
                to="/"
                className="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                ホームに戻る
              </Link>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="pt-24 pb-20">
          <div className="max-w-4xl mx-auto px-6">
            <h1 className="text-4xl font-bold text-gray-900 mb-8">プライバシーポリシー（個人情報保護方針）</h1>

            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed mb-8">
                株式会社dot Blue（以下「当社」）は、当社が運営するウェブサイト（aidotblue.com）および当社が提供する法人向けサービス（以下総称して「本サービス」）において、個人情報の重要性を認識し、個人情報の保護に関する法律その他関係法令・ガイドラインを遵守するとともに、以下のとおり個人情報等を取り扱います。
              </p>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">1. 事業者情報</h2>
                <div className="bg-gray-50 rounded-lg p-6 space-y-2">
                  <p className="text-gray-700"><strong>事業者名：</strong>株式会社dot Blue</p>
                  <p className="text-gray-700"><strong>住所：</strong>東京都目黒区目黒二丁目11番3号</p>
                  <p className="text-gray-700"><strong>代表者：</strong>平舘慶大（代表取締役）</p>
                  <p className="text-gray-700"><strong>連絡先：</strong>contact@aidotblue.com</p>
                </div>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">2. 定義</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  本ポリシーにおいて「個人情報」とは、個人情報の保護に関する法律に定義される個人情報をいいます。
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  また、当社が取得する情報のうち、単体では個人を特定できない場合でも、端末情報や閲覧履歴等と組み合わさることで個人の識別につながり得る情報（例：端末識別子等）を、必要に応じて本ポリシーの対象として取り扱います。
                </p>
                <div className="bg-blue-50 rounded-lg p-5">
                  <p className="text-sm font-semibold text-gray-900 mb-2">※用語補足：</p>
                  <ul className="space-y-1 text-sm text-gray-700">
                    <li><strong>IPアドレス：</strong>インターネット接続時に端末へ割り当てられる番号</li>
                    <li><strong>Cookie（クッキー）等：</strong>閲覧者の端末に保存される小さな情報（同等技術としてLocalStorage等を含みます）</li>
                    <li><strong>セッションID：</strong>閲覧・利用の一連の流れを区別するための識別子</li>
                  </ul>
                </div>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">3. 取得する情報</h2>
                <p className="text-gray-700 leading-relaxed mb-4">当社は、以下の情報を取得する場合があります。</p>

                <h3 className="text-xl font-bold text-gray-900 mb-3">(1) お客様等からご提供いただく情報</h3>
                <div className="mb-6 space-y-4">
                  <div>
                    <p className="font-semibold text-gray-900 mb-2">お問い合わせフォーム（Google Form等）でご入力いただく情報</p>
                    <p className="text-gray-700 pl-4">会社名、氏名、メールアドレス、相談内容、年間採用人数レンジ 等</p>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 mb-2">取引・商談に関連して取得する情報</p>
                    <p className="text-gray-700 pl-4">名刺情報、商談メモ、契約・請求に関連する情報 等</p>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 mb-2">当社の採用に応募いただく際に取得する情報</p>
                    <p className="text-gray-700 pl-4">氏名、連絡先、職務経歴書・履歴書、その他選考に必要な情報 等</p>
                  </div>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3">(2) 自動的に取得する情報（アクセス情報等）</h3>
                <p className="text-gray-700 leading-relaxed mb-3">
                  当社は、サイトの利用状況の把握・品質改善・セキュリティ確保のため、以下の情報を自動的に取得する場合があります。
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-1 text-gray-700">
                  <li>閲覧ページ、参照元、アクセス日時、ブラウザ/端末種別、IPアドレス、ログ情報 等</li>
                  <li>アクセス解析ツール（例：Google Analytics 4、Mixpanel）により取得される計測データ</li>
                </ul>

                <h3 className="text-xl font-bold text-gray-900 mb-3">(3) AIチャット等の対話ログに関する情報</h3>
                <p className="text-gray-700 leading-relaxed mb-3">
                  当社は、本サービス上で提供するAIチャット等において、品質改善や不正利用防止のため、以下の情報を取得する場合があります。
                </p>
                <p className="text-gray-700 pl-4 mb-3">入力された発話内容、閲覧ページURL、セッションID、端末情報 等</p>
                <p className="text-gray-700 leading-relaxed">
                  なお、当社は<strong>入力欄等で「個人情報を書かない」</strong>旨の注意を案内する等、個人情報が入力されない運用を原則とします。
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">4. 利用目的</h2>
                <p className="text-gray-700 leading-relaxed mb-4">当社は、取得した情報を以下の目的で利用します。</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>お問い合わせへの対応、連絡、資料送付、商談・契約手続きのため</li>
                  <li>本サービスの提供、運用、サポート対応のため</li>
                  <li>本サービスの品質改善（ログ分析、UI改善、FAQ/ナレッジ整備等）のため</li>
                  <li>セキュリティの確保（不正アクセス検知、障害対応、監査等）のため</li>
                  <li>当社サービス、イベント、セミナー、ニュース等のご案内（マーケティング）のため</li>
                  <li>当社の採用選考および採用活動のため</li>
                  <li>法令遵守、紛争対応等のため</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">5. Cookie等およびアクセス解析ツールの利用</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  当社は、サイトの利便性向上や利用状況の把握のため、<strong>Cookie等（同等技術を含む）</strong>を利用する場合があります。
                </p>
                <p className="text-gray-700 leading-relaxed mb-3">当社が利用する主な解析ツールは以下です。</p>
                <ul className="list-disc pl-6 mb-4 space-y-1 text-gray-700">
                  <li>Google Analytics 4</li>
                  <li>Google Search Console</li>
                  <li>Mixpanel</li>
                </ul>
                <p className="text-sm text-gray-600">
                  ※各ツールの仕組みや無効化（オプトアウト）の方法は、各提供事業者の案内をご確認ください。<br />
                  （例：<a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://tools.google.com/dlpage/gaoptout</a>）
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">6. 第三者提供</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  当社は、法令に基づく場合その他正当な理由がある場合を除き、ご本人の同意なく個人情報を第三者に提供しません。
                </p>
                <p className="text-sm text-gray-600">
                  ※補足：当社が外部サービス提供事業者に業務を委託して情報を取り扱わせること（次条）は、一般に「第三者提供」とは区別されます（委託先に対し適切な監督を行います）。
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">7. 委託（外部サービスの利用）</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  当社は、利用目的の達成に必要な範囲で、個人情報等の取扱いを外部事業者に委託する場合があります。
                </p>
                <p className="text-gray-700 mb-3">例：アクセス解析、フォーム運用、クラウドインフラ、LLM（大規模言語モデル）API 等</p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  当社は委託先の選定にあたり、適切な安全管理が図られるよう必要な措置を講じます。
                </p>
                <div className="bg-gray-50 rounded-lg p-5">
                  <p className="font-semibold text-gray-900 mb-3">当社が利用する外部サービス（例）</p>
                  <ul className="list-disc pl-6 space-y-1 text-gray-700">
                    <li>Google（Google Forms、Google Analytics、Google Search Console、GCP 等）</li>
                    <li>Mixpanel</li>
                    <li>Cloudflare</li>
                    <li>OpenAI API</li>
                  </ul>
                </div>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">8. 海外へのデータ移転（越境移転）</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  当社が利用する外部サービス提供事業者（例：OpenAI API 等）のサーバが日本国外に所在する場合、取得した情報が日本国外で保存・処理される可能性があります。
                </p>
                <p className="text-gray-700 leading-relaxed">
                  当社は、当該提供事業者の安全管理措置等を踏まえ、必要に応じて適切な対応を行います。
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">9. 安全管理措置</h2>
                <p className="text-gray-700 leading-relaxed">
                  当社は、個人情報等の漏えい、滅失または毀損の防止その他の安全管理のため、組織的・人的・技術的な安全管理措置を講じます。具体的な内容は、セキュリティページ（/security）にて可能な範囲で開示します。
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">10. 保有期間および削除</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  当社は、取得した情報を、利用目的の達成に必要な期間保持し、目的達成後は合理的な期間内に削除または匿名化等の措置を講じます。
                </p>
                <p className="text-gray-700 leading-relaxed">
                  なお、法令等により保存が必要な場合は当該法令等に従います。
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">11. 開示等の請求（開示・訂正・利用停止等）</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  ご本人から、個人情報の開示、訂正、利用停止、削除等を求められた場合、法令に従い適切に対応します。
                </p>
                <div className="bg-gray-50 rounded-lg p-5 space-y-3">
                  <p className="text-gray-700"><strong>申請窓口：</strong>contact@aidotblue.com</p>
                  <p className="text-gray-700">
                    <strong>本人確認：</strong>ご本人確認のため、登録メールアドレスからの送信や追加情報の提示をお願いする場合があります。
                  </p>
                </div>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">12. 未成年の個人情報</h2>
                <p className="text-gray-700 leading-relaxed">
                  未成年の方が当社サービスをご利用いただく場合、必要に応じて保護者の同意を得た上でご利用ください。
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">13. 本ポリシーの変更</h2>
                <p className="text-gray-700 leading-relaxed">
                  当社は、法令の改正や運用の変更等に応じて本ポリシーを改定することがあります。改定した場合、当社ウェブサイト上に掲示します。
                </p>
              </section>

              <div className="border-t-2 border-gray-200 pt-6 mt-10">
                <p className="text-gray-700 font-semibold">制定日：2026年1月19日</p>
                <p className="text-gray-700 font-semibold">株式会社dot Blue</p>
              </div>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-gray-900 text-white py-8">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="flex items-center gap-3">
                <span className="text-lg font-bold">dot Blue</span>
              </div>
              <div className="flex gap-6 text-sm">
                <Link to="/privacy-policy" className="hover:text-blue-400 transition-colors cursor-pointer">
                  プライバシーポリシー
                </Link>
                <a href="mailto:contact@aidotblue.com" className="hover:text-blue-400 transition-colors cursor-pointer">
                  お問い合わせ
                </a>
              </div>
            </div>
            <div className="text-center text-sm text-gray-400 mt-6">
              Copyright © dot Blue Inc. All Rights Reserved.
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
